import('./index');
declare module '*.png';
declare module '*.jpg';
